import { render, staticRenderFns } from "./OrdersPerProductReport.vue?vue&type=template&id=2b7471c0&scoped=true&"
import script from "./OrdersPerProductReport.vue?vue&type=script&lang=js&"
export * from "./OrdersPerProductReport.vue?vue&type=script&lang=js&"
import style0 from "./OrdersPerProductReport.vue?vue&type=style&index=0&id=2b7471c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7471c0",
  null
  
)

export default component.exports